import SjQuestionUploadVideoBox from './src/main.js'

export default SjQuestionUploadVideoBox



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-upload-video-box/index.js